export default "__VITE_ASSET__B29evY0Q__"